import { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AssistenteIAWidget from '../components/AssistenteIAWidget';
import BarraLateral from '../components/BarraLateral';
import { useAuth } from '../contexts/AuthContext';

const LayoutPrivado = () => {
  const { user, fazenda, mustChangePassword, loading } = useAuth();
  const [sidebarMinimized, setSidebarMinimized] = useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <p className="text-gray-500 text-sm">Carregando...</p>
      </div>
    );
  }

  if (!user || !fazenda) {
    return <Navigate to="/" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/trocar-senha" replace />;
  }

  return (
    <>
      <BarraLateral onToggle={setSidebarMinimized} />

      <div
        style={{
          marginLeft: sidebarMinimized ? '68px' : '280px',
          transition: 'margin-left 0.3s ease',
          padding: '20px',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Outlet />
      </div>

      <AssistenteIAWidget />
    </>
  );
};

export default LayoutPrivado;
